import * as React from "react";
import PropTypes from "prop-types";
const SvgSportsVelomobileNormalSmall = React.forwardRef(
  ({ color = "currentColor", size = 24, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="M12.337 17h-1.064c-1.49 0-2.963-.317-4.32-.927a3.497 3.497 0 01-2.38 2.759A3.5 3.5 0 010 15.5V7.054c0-.359.18-.739.55-.95C1.014 5.84 2.819 5 7.023 5c3.907 0 7.73 1.164 10.748 2.832 2.971 1.643 5.355 3.887 6.107 6.188.282.862.004 1.663-.53 2.2-.507.508-1.231.78-1.957.78h-2.728a3.5 3.5 0 01-6.326 0zM3.785 7.219c-.852.131-1.429.297-1.785.424V13h.772c1.63 0 3.238.378 4.697 1.105a8.533 8.533 0 003.804.895h.762a3.501 3.501 0 016.93 0h2.426c.25 0 .447-.099.54-.192a.199.199 0 00.056-.083c.002-.006.008-.03-.01-.084-.517-1.583-2.361-3.5-5.155-5.048L15.414 11H6.485zm1.2 8.073A8.533 8.533 0 002.773 15h-.686a1.499 1.499 0 00-.086.498v.002a1.5 1.5 0 102.986-.208zm1.112-8.277L7.515 9h7.07l.335-.334C12.534 7.65 9.789 7 7.023 7c-.326 0-.634.005-.926.015zM15.5 14a1.5 1.5 0 100 3 1.5 1.5 0 000-3z"
        fill=""
      />
    </svg>
  )
);
SvgSportsVelomobileNormalSmall.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  title: PropTypes.string,
  titleId: PropTypes.string,
};
export default SvgSportsVelomobileNormalSmall;
